export const lsSave = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const lsGet = (key) => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
};

export const lsUpdate = (key, newValue) => {
  localStorage.setItem(key, JSON.stringify(newValue));
};

export const lsDelete = (key) => {
  localStorage.removeItem(key);
};
